export default __webpack_public_path__ + "static/spot-vitamins__immune-inflammation-free-02-92264efb9b83eee7475d485d62aeffdd.jpg";